<template>
  <nav class="dashboard-navigation">
    <div
      class="item"
      v-for="(el, name) in elements"
      :key="name"
      v-scroll-to="getClass(name)"
      :class="{ active: active === name }"
    >
      {{ name }}
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    elements: Object,
    container: {},
  },
  data() {
    return {
      scroll: 0,
      active: Object.keys(this.elements)[0],
      fixPositions: false,
    }
  },
  computed: {
    positions() {
      return Object.keys(this.elements).reduce((tmp, key, i) => {
        const el = this.elements[key]
        const pos = this.getPos(el)
        tmp[key] = this.fixPositions ? (i ? pos : 0) : pos
        return tmp
      }, {})
    },
    correctionTop() {
      if (this.elements) {
        return this.container.getBoundingClientRect().top
      } else return 0
    },
  },
  methods: {
    getClass(name) {
      const list = {
        Today: 'today-events',
        Important: 'important-list',
        Notifications: 'notifications-list',
      }

      return {
        el: `.dashboard-item.${list[name]}`,
        container: '#dashboard-content',
      }
    },
    getPos(el) {
      return (el || 0) && el.getBoundingClientRect().top - this.correctionTop
    },
    fixPos() {
      if (!this.fixPositions && this.scroll) {
        this.fixPositions = true
      }
    },
    scrolled() {
      this.fixPos()
      this.scroll = this.container.scrollTop
      for (const name in this.positions) {
        if (this.scroll >= this.positions[name] - 10) {
          this.active = name
        }
      }
    },
    scrollTo(name) {
      if (this.container) {
        let top = this.getPos(this.elements[name])
        try {
          this.container.scroll({
            top,
            behavior: 'smooth',
          })
        } catch (e) {
          this.container.scrollTop = top
        }
      }
    },
  },
  watch: {
    container(container) {
      if (container) {
        this.scrolled()
        container.addEventListener('scroll', () => this.scrolled())
      }
    },
  },
}
</script>

<style lang="scss">
.dashboard-navigation {
  display: flex;
  margin: 0 10px 10px;

  .item {
    padding-top: 10px;
    margin: 0 10px;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: $dark;
    cursor: pointer;
    border-top: 3px solid transparent;
    user-select: none;

    &:hover {
      color: $dark;
    }

    &.active {
      color: $text;
      border-top-color: $primary;
    }
  }
}
</style>
